import { Component, input, InputSignal, signal } from '@angular/core';

import { MDIconComponent } from '@melodic-ui/components';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
	selector: 'lb-copy-to-clipboard',
	standalone: true,
	imports: [MDIconComponent],
	templateUrl: './copy-to-clipboard.component.html',
	styleUrl: './copy-to-clipboard.component.scss'
})
export class CopyToClipboardComponent {
	public textToCopy: InputSignal<string> = input.required<string>();
	public showConfirmation: InputSignal<boolean> = input<boolean>(false);
	public confirmationText: InputSignal<string> = input<string>('copied to clipboard');

	isTextVisible = signal(false); // Toggle visibility
	textPosition = { x: 0, y: 0 }; // Store mouse click coordinate

	constructor(private clipboard: Clipboard) {}

	copyText(event: MouseEvent) {
		event.stopPropagation();
		this.clipboard.copy(this.textToCopy());
		if (this.showConfirmation()) {
			this.isTextVisible.set(true);
			this.textPosition = { x: event.layerX, y: event.layerY };
			setTimeout(() => {
				this.isTextVisible.set(false);
			}, 2000);
		}
	}
}
